export default "/_next/static/images/sheila-marcelo-dedbcfcd8012663a6862f0b3611afe1f.png";